import { Instagram, Play, ArrowUpRight } from "lucide-react";

export default function InstagramReels({ reels, photos, profileUrl }) {
  const list = (reels || []).filter((r) => r.url).slice(0, 6);
  if (list.length === 0) return null;
  const target = profileUrl || list[0].url;
  return (
    <section id="instagram" className="reels section" data-testid="reels-section">
      <div className="reels-head">
        <div>
          <p className="eyebrow">
            <Instagram size={12} /> LATEST REELS
          </p>
          <h2>
            Fresh work,
            <br />
            <em>every week.</em>
          </h2>
        </div>
        <a
          className="line-btn reels-cta"
          href={target}
          target="_blank"
          rel="noreferrer"
          data-testid="reels-view-more"
        >
          VIEW MORE ON INSTAGRAM <ArrowUpRight size={14} />
        </a>
      </div>
      <div className="reels-strip" data-testid="reels-strip">
        {list.map((r, i) => {
          const backdrop = r.image || photos?.[(i * 3) % (photos?.length || 1)]?.url;
          return (
            <a
              key={r.id || r.url}
              href={r.url}
              target="_blank"
              rel="noreferrer"
              className="reel-tile"
              data-testid={`reel-tile-${i + 1}`}
              aria-label={`Open Instagram reel ${i + 1}`}
            >
              {backdrop && <img src={backdrop} alt="" loading="lazy" />}
              <div className="reel-shade" />
              <div className="reel-play" aria-hidden>
                <Play size={22} fill="currentColor" />
              </div>
              <span className="reel-label">REEL {String(i + 1).padStart(2, "0")}</span>
              <span className="reel-tag">
                <Instagram size={11} /> WATCH ON INSTAGRAM
              </span>
            </a>
          );
        })}
      </div>
    </section>
  );
}
